import { simpleAction } from '../../utils';
import * as TYPES from './types';

/**
 * Check login
 */
export const checkLogin = simpleAction(TYPES.AUTH_LOGIN_CHECK);

/**
 * Login action
 */
export const loginAction = simpleAction(TYPES.AUTH_LOGIN_REQUEST);

/**
 * Login success
 */
export const loginSuccess = simpleAction(TYPES.AUTH_LOGIN_SUCCESS);

/**
 * Login _loading
 */
export const loginLoading = simpleAction<boolean>(TYPES.AUTH_LOGIN_LOADING);

/**
 * Login fail
 */
export const loginFail = simpleAction(TYPES.AUTH_LOGIN_FAIL);

/**
 * Execute logout
 */
export const executeLogout = simpleAction(TYPES.AUTH_LOGOUT_REQUEST);

/**
 * Logout success
 */
export const logoutSuccess = simpleAction(TYPES.AUTH_LOGOUT_SUCCESS);

/**
 * Clear auth errors
 */
export const clearAuthErrors = simpleAction(TYPES.AUTH_ERRORS_CLEAR);
